/* ------------------ MESSAGE TICKS COMPONENT ------------------ */

/**
 * Message Ticks Component - WhatsApp Style
 * Shows delivery/read status with tick icons:
 * - Clock icon: Sending (message being sent)
 * - Single gray tick: Sent (message sent to server)
 * - Double gray tick: Delivered (recipient received)
 * - Double blue tick: Read (recipient has seen the message)
 */
interface MessageTicksProps {
  status: "sending" | "sent" | "delivered" | "read" | "failed";
}

const MessageTicks: React.FC<MessageTicksProps> = ({ status }) => {
  const tickStyle = "text-[13px] tracking-[-3px] font-normal";
  
  if (status === "sending") {
    // Clock icon for sending (white/translucent for gradient bg)
    return (
      <svg className="w-[16px] h-[11px] text-white/70" viewBox="0 0 16 11" fill="currentColor">
        <path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm.5-10H7v5l4.25 2.5.75-1.23-3.5-2.08V4z" transform="scale(0.6875) translate(2, 1)"/>
      </svg>
    );
  }
  
  if (status === "failed") {
    return <span className="text-red-300 text-[11px]">!</span>;
  }
  
  if (status === "sent") {
    // Single tick - sent to server (white/translucent)
    return (
      <svg className="w-[16px] h-[11px] text-white/70" viewBox="0 0 16 11" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M11 2L6 8L3 6" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  
  if (status === "delivered") {
    // Double tick - delivered (white/translucent)
    return (
      <svg className="w-[16px] h-[11px] text-white/70" viewBox="0 0 16 11" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M11 2L6 8L3 6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 2L9 8L7.5 6.7" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  
  if (status === "read") {
    // Double tick - read (bright white/cyan)
    return (
      <svg className="w-[16px] h-[11px] text-cyan-300" viewBox="0 0 16 11" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M11 2L6 8L3 6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14 2L9 8L7.5 6.7" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  
  return null;
};

export default MessageTicks;